export const findRideEn = {
  pageTitle: "Find a Ride — Duri Ridesharing",
  pageMetaDescription:
    "Find and book shared intercity and intra-city rides in seconds. Enter pickup, drop, date and seats on Duri.",
  heroTitle: "Find a Ride",
  heroSubtitleBefore: "Book a ",
  heroSubtitleHighlight: "shared intercity or intra-city ride",
  heroSubtitleAfter: " in seconds.",

  pickupLabel: "Pickup Location",
  pickupPlaceholder: "Enter Pickup Location",
  dropLabel: "Drop Location",
  dropPlaceholder: "Enter Drop Location",
  dateLabel: "Date",
  pickDate: "Choose a date",
  seatsLabel: "Seats Required",
  selectSeats: "Select seats",
  myLocation: "Use my location",
  today: "Today",
  tomorrow: "Tomorrow",
  findRideCta: "Find a Ride",
  searchingCta: "Searching rides…",

  locationDenied: "Location access denied. Please search pickup manually.",
  selectPickupDrop: "Please select pickup and drop from the location suggestions.",
  selectDate: "Please select a travel date.",
  selectSeatsError: "Please select at least 1 seat.",
  pickupDropDifferent: "Pickup and drop must be different locations.",
  loginRequired: "Please log in to search for rides.",
  notifyLoginRequired:
    "Please log in to save this search and get notified later.",
  searchFailed: "Unable to search rides right now. Please try again.",

  searchingTitle: "Finding rides…",
  searchingSubtitle: "Matching hosts for your route and date.",

  noRidesTitle: "No rides found",
  noRidesOops: "Oops...",
  noRidesBody:
    "No rides are available for this route yet. Save your search and relax, we'll notify you the moment a matching ride becomes available",
  refresh: "Refresh",
  saveNotifyCta: "Save & notify me later",
  saveNotifySaving: "Saving…",
  saveNotifyTitle: "You're all set",
  saveNotifySuccess:
    "We'll notify you when a matching ride is available for this route. You can close this and relax — we'll reach out as soon as a host posts a match.",
  saveNotifyDone: "Got it",
  saveNotifyFailed: "Unable to save your notify request. Please try again.",
  featureSafeRides: "Safe rides",
  featureVerifiedUsers: "Verified users",
  featureBestMatches: "Best matches",

  trustSafeTitle: "Trusted & Safe",
  trustSafeBody: "Verified users for a secure experience",
  trustQuickTitle: "Quick Booking",
  trustQuickBody: "Book your intercity or intra-city ride in just a few taps",
  trustSaveTitle: "Save Together",
  trustSaveBody: "Share rides, save money and travel together",

  ridesAvailableTitle: "{count} Rides Available",
  ridesAvailableBody:
    "Great news! Matching rides are available for your route. View details and book a seat.",
  viewAndBookCta: "View & Book Ride",
  editDetails: "Edit Details",
  editSearch: "Edit search",
  editLocations: "Edit locations",
  perSeat: "per seat",
  seatsLeft: "{count} seats available",
  noRideCards: "No bookable rides with a ride ID were returned for this search.",
  rideIdLabel: "Ride {id}",
} as const;

export type FindRideTranslationKeys = keyof typeof findRideEn;
export type FindRideTranslations = Record<FindRideTranslationKeys, string>;
